export default __webpack_public_path__ + "static/media/drone.b43551a3.jpg";